import {
  FETCH_CUSTOMER_BEGIN,
  FETCH_CUSTOMER_SUCCESS,
  FETCH_CUSTOMER_FAILURE,
  CURRENT_DISCOUNTCODE,
  CURRENT_GIFTCARD,
  FETCH_CUSTOMERGIFTCARD_BEGIN,
  FETCH_CUSTOMERGIFTCARD_SUCCESS,
  FETCH_CUSTOMERGIFTCARD_FAILURE,
  CURRENT_CHARITY_DONATE,
} from "../actions/constants/constants";

const CUSTOMER_STATE = {
  loading: true,
  customer: {},
  currentGiftcard: {},
  currentDiscountCode: {},
  giftcards: [],
  currentCharityDonate: {},
  error: null,
};

const CustomerReducer = (state = CUSTOMER_STATE, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        customer: action.payload,
      };
    case FETCH_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        customer: {},
      };
    case FETCH_CUSTOMERGIFTCARD_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_CUSTOMERGIFTCARD_SUCCESS:
      return {
        ...state,
        loading: false,
        giftcards: action.payload,
      };
    case FETCH_CUSTOMERGIFTCARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        giftcards: {},
      };
    case CURRENT_DISCOUNTCODE:
      return {
        ...state,
        currentDiscountCode: action.payload,
      };
    case CURRENT_GIFTCARD:
      return {
        ...state,
        currentGiftcard: action.payload,
      };
    case CURRENT_CHARITY_DONATE:
      return {
        ...state,
        currentCharityDonate: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default CustomerReducer;
